import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  AtlasBannerRef,
  ATLAS_BANNER_DATA,
} from '@wellsky/atlas-ui/banners';

export interface BannerData {
  content: string;
  imageURL: string;
  primaryAction: string;
  secondaryAction: string;
}

@Component({
  selector: 'app-banner-demo-t3',
  templateUrl: './banner-demo-t3.component.html',
})
export class BannerDemoT3Component {

  constructor(private route: Router, private bannerRef: AtlasBannerRef<BannerDemoT3Component>,
    @Inject(ATLAS_BANNER_DATA) public data: BannerData) {
  }

  /**
   * Perform Dismiss Action for Banner
   */
  getDismissAction() {
    // Trigger close for banner
    this.bannerRef.close();
  }

  /**
   * Perform Action on Banner
   */
  performAction() {
    // Trigger close for banner
    this.bannerRef.close();

    // Perform action on banner
    this.route.navigateByUrl('button');
  }
}
